import React from 'react';
import PropTypes from 'prop-types';
import Button from '@welldev-group/rcl-button';
import { I18nText } from '@welldev-group/react-comp-lib';
import WorkspaceCard from '../WorkspaceCard';

const WorkspaceTableDeleteRow = ({
  affiliateId,
  toggleDeletable,
  index,
  workspace,
  deleteWorkspace,
  fetchWorkspaces,
}) => {
  const onClick = () => {
    deleteWorkspace(workspace.id, affiliateId).then(response => {
      if (response.error === null) {
        fetchWorkspaces();
      }
    });
  };
  return (
    <WorkspaceCard>
      <div className="col-6 workspace-table__name-field">
        <I18nText id="workspace.delete.text" />
      </div>

      <div className="col-6 align-self-center workspace-table__actions-field">
        <div className="workspace-table__actions-field-save">
          <Button
            label={<I18nText id="workspace.delete.button_label.delete" />}
            onClick={onClick}
            version="v2"
            size="small"
            type="primary"
          />
        </div>
        <div className="workspace-table__actions-field-cancel">
          <Button
            label={<I18nText id="workspace.button_label.cancel" />}
            onClick={() => toggleDeletable(index, false)}
            version="v2"
            size="small"
            type="primary"
          />
        </div>
      </div>
    </WorkspaceCard>
  );
};

WorkspaceTableDeleteRow.propTypes = {
  workspace: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
  }).isRequired,
  affiliateId: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  toggleDeletable: PropTypes.func.isRequired,
  deleteWorkspace: PropTypes.func.isRequired,
  fetchWorkspaces: PropTypes.func.isRequired,
};

export default WorkspaceTableDeleteRow;
